// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class ByteStringNodeId implements flatbuffers.IUnpackableObject<ByteStringNodeIdT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ByteStringNodeId {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsByteStringNodeId(
    bb: flatbuffers.ByteBuffer,
    obj?: ByteStringNodeId,
  ): ByteStringNodeId {
    return (obj || new ByteStringNodeId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsByteStringNodeId(
    bb: flatbuffers.ByteBuffer,
    obj?: ByteStringNodeId,
  ): ByteStringNodeId {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ByteStringNodeId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  namespaceIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  identifier(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  identifierLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  identifierArray(): Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return new Uint8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  static startByteStringNodeId(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addNamespaceIndex(builder: flatbuffers.Builder, namespaceIndex: number) {
    builder.addFieldInt16(0, namespaceIndex, 0);
  }

  static addIdentifier(builder: flatbuffers.Builder, identifierOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, identifierOffset, 0);
  }

  static createIdentifierVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startIdentifierVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endByteStringNodeId(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // identifier
    return offset;
  }

  static createByteStringNodeId(
    builder: flatbuffers.Builder,
    namespaceIndex: number,
    identifierOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ByteStringNodeId.startByteStringNodeId(builder);
    ByteStringNodeId.addNamespaceIndex(builder, namespaceIndex);
    ByteStringNodeId.addIdentifier(builder, identifierOffset);
    return ByteStringNodeId.endByteStringNodeId(builder);
  }

  unpack(): ByteStringNodeIdT {
    return new ByteStringNodeIdT(
      this.namespaceIndex(),
      this.bb!.createScalarList<number>(this.identifier.bind(this), this.identifierLength()),
    );
  }

  unpackTo(_o: ByteStringNodeIdT): void {
    _o.namespaceIndex = this.namespaceIndex();
    _o.identifier = this.bb!.createScalarList<number>(
      this.identifier.bind(this),
      this.identifierLength(),
    );
  }

  unpackFields(...fields: string[]): ByteStringNodeIdT {
    const t = new ByteStringNodeIdT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("namespace_index")) {
      t.namespaceIndex = this.namespaceIndex();
    }
    if (fieldSet.has("identifier")) {
      t.identifier = this.bb!.createScalarList<number>(
        this.identifier.bind(this),
        this.identifierLength(),
      );
    }
    return t;
  }
}

export class ByteStringNodeIdT implements flatbuffers.IGeneratedObject {
  constructor(
    public namespaceIndex: number = 0,
    public identifier: number[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.identifier === null || this.identifier === undefined) {
      throw new Error('Required field "identifier" is not set');
    }
    const identifier = ByteStringNodeId.createIdentifierVector(builder, this.identifier);

    return ByteStringNodeId.createByteStringNodeId(builder, this.namespaceIndex, identifier);
  }

  clone(): ByteStringNodeIdT {
    const obj = new ByteStringNodeIdT();
    obj.namespaceIndex = this.namespaceIndex;
    obj.identifier = [...this.identifier];
    return obj;
  }

  equals(other: ByteStringNodeIdT): boolean {
    if (this.namespaceIndex !== other.namespaceIndex) return false;
    if (this.identifier.length !== other.identifier.length) return false;
    for (let i = 0; i < this.identifier.length; i++) {
      if (this.identifier[i] !== other.identifier[i]) return false;
    }
    return true;
  }
}

export function verifyByteStringNodeId(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "identifier");
  } finally {
    verifier.popDepth();
  }
}
